import { ObservableArray, View } from "binder"
import { entry, TransactionCreationViewModel } from "./transactionCreation-viewModel"

export class TransactionCreationView extends View<TransactionCreationViewModel>{
    GetViewUniqueId(): string {
        return "V-05B4A61E-2A55-4DA0-85CE-EC68CDB34429"
    }
    loadHtml(): string {
        let element = require('./transactionCreation.html').default;
        let style = require('./transactionCreation.less');
        return element;
    }
    constructor() {
       super();
    }
    
    public set time(v: moment.Moment) { this._time = v; } public get time(): moment.Moment { return this._time;} private _time: moment.Moment;
    public set transactionTitle(v: string) { this._transactionTitle = v; } public get transactionTitle(): string { return this._transactionTitle;} private _transactionTitle: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code;} private _code: string;
    public set refCode(v: string) { this._refCode = v; } public get refCode(): string { return this._refCode;} private _refCode: string;
    public set comment(v: string) { this._comment = v; } public get comment(): string { return this._comment;} private _comment: string;
    public set entries(v: ObservableArray<entry>) { this._entries = v; } public get entries(): ObservableArray<entry> { return this._entries;} private _entries: ObservableArray<entry>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    
    addNewEntry(){
        this.dataContext.addNewEntry();
    }
    requestCloseTransactionCreation(){
        this.dataContext.requestCloseTransactionCreation();
    }

    save(){
        this.dataContext.save();
    }
}
